<template>
  <span>
    <p v-for="(charger, idx) in data"
      :key="idx"
      class="divided"
      :style="'top: ' + charger.positionY + 'px; left: ' + charger.positionX + 'px; position: absolute;'"
    >
      <span class="spklu-marker-c">
        <v-img
          src="@/assets/icon/ic_mapsmarker.svg"
        ></v-img>
      </span>
      <span class="divider" :style="'width: ' + charger.lineLength + 'px;'"></span>
      <span class="spklu-content-c">
        <span v-for="(chargebox, k) in charger.chargers"
              :key="k"
              class="spklu-content-col"
        >
          <span class="spklu-content-c-title">{{ chargebox.chargeBoxName }}</span>
          <span v-for="connector in chargebox.connectors"
                :key="connector.connectorId"
                :class="connectorClassByStatus(connector.connectorStatus)"
          >
            <!-- status 2 -> in use -->
            <span v-if="connector.connectorStatus === 2">
              {{ connector.connectorName + ' ' + replaceIfEmpty(connector.batPercentage) + '% - ' + secondToMinutes(connector.estRemainingTimeS) + '’'}}
            </span>
            <span v-else>
              {{ connector.connectorName }}
            </span>
          </span>
        </span>
      </span>
    </p>
  </span>
</template>
<script>
export default {
  name: 'DiagramRight',
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
</script>
